<template>
  <div class="side-nav">
    <!-- 'is-desktop': item.functionName == '工作台', -->
    <div
      class="nav-item"
      :class="{
        open: item.isOpen,
        'leaf-nav-item': !item.children || !item.children.length,
        'is-parent': item.isParent,
        'sy-menu': item.functionName == '仿真实验',
      }"
      v-for="(item, index) in navs"
      :key="index"
    >
      <!-- 'desktop-menu': item.functionName == '工作台', -->
      <div
        class="nav-item-content link"
        data-io-click="tracker"  @click="toggle(item)"
        :class="[
          {
            'router-link-active': judgePathActive(item.redirectUrl),
            'parent-menu-active': item.isActive && !item.isMenu,
          },
          'link' + item.functionId,
        ]"
      >
        <!-- <div
          class="icon-box"
          v-if="item.functionName != '工作台'"
          :class="{
            'is-parent-icon-box':
              item.isParent && (!item.children || !item.children.length),
            'is-child-icon-box': item.children && item.children.length,
            'is-leaf-icon-box': !item.isParent,
          }"
        >
          <div class="tri-icon" :class="{ 'is-active': item.isActive }"></div>
        </div>
        v-else -->
        <div class="icon-box">
          <!-- <i class="iconfont icon-gongzuotai-n"></i> -->
          <i class="iconfont" :class="item.iconName" />
        </div>
        <!-- <div
          class="icon-box"
          v-if="
            item.isParent &&
            (!item.children || !item.children.length) &&
            item.functionName != '工作台'
          "
        >
          <div class="circle-icon"></div>
        </div> -->
        <div
          class="circle-icon"
          v-if="!item.isParent && item.functionName != '工作台'"
        ></div>
        {{ item.functionName }}
      </div>
      <!-- <transition name="slide">  v-show="item.isOpen"-->
      <div
        :class="{ 'is-open': item.isOpen }"
        class="sub-menu"
        v-if="item.children && item.children.length"
      >
        <SideNav
          :parentItem="item"
          :loginStatus="loginStatus"
          :enterWxtStatus="enterWxtStatus"
          @toLoginLayout="toLoginLayout"
          @openNoAuthDialog="openNoAuthDialog"
          @toPath="toPath"
          :navs="item.children"
          @toggle="toggle"
        ></SideNav>
      </div>
      <!-- </transition> -->
    </div>
  </div>
</template>
<script>
const SHOWBKUPDATEICON = "SHOWBKUPDATEICON";
import { mapMutations, mapState } from "vuex";
export default {
  name: "SideNav",
  props: {
    navs: {
      type: Array,
      default: () => [],
    },
    loginStatus: {
      type: Boolean,
      default: false,
    },
    enterWxtStatus: {
      type: Boolean,
      default: false,
    },
    parentItem: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState(["showSyTip"]),
  },
  data() {
    return {};
  },
  methods: {
    ...mapMutations(["changeShowSyTip", "changeShowAddBkTip"]),
    toggle(item) {
      if (item.children && item.children.length && !item.isMenu) {
        this.$emit("toggle", {
          item,
        });
        // this.$set(item,'isOpen',!item.isOpen)
        // item.isOpen = !item.isOpen;
      } else if (item.isMenu) {
        // console.log("跳转路由", this.parentItem);
        //
        // this.parentItem =  item.functionName == '工作台' ? item : this.parentItem
        this.handlePath(item.redirectUrl, item);
      }
    },
    judgePathActive(url) {
      if (!url) return;
      return this.$route.path.indexOf(url.split("/")[1]) > -1;
    },
    handlePath(pathName, item) {
      if (!this.loginStatus) {
        this.$emit("toLoginLayout");
        return;
      }
      if (!this.enterWxtStatus) {
        this.$emit("openNoAuthDialog");
        return;
      }
      let path = this.$route.path;
      if (pathName == "/bk") {
        this.showBkUpdateIcon = false;
        localStorage.setItem(SHOWBKUPDATEICON, true);
      }
      if (pathName == "/desktop") {
        this.changeShowAddBkTip(false);
      }
      if (pathName == "/lab") {
        this.showSyTip && this.changeShowSyTip(false);
      }
      if (path != pathName) {
        this.$emit("toPath", {
          pathName,
          parentItem: item.isParent ? item : this.parentItem,
        });
      }
    },
    toLoginLayout() {
      this.$emit("toLoginLayout");
    },
    openNoAuthDialog() {
      this.$emit("openNoAuthDialog");
    },
    toPath(pathName) {
      this.$emit("toPath", pathName);
    },
  },
};
</script>
<style scoped lang="scss">
.side-nav {
  // width: 112px;
  margin-top: 16px;
  .nav-item {
    cursor: pointer;
    // padding-bottom: 4px;
    margin-bottom: 16px;
    .sub-menu {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.2s ease-out;
      margin-top: 4px;
      .side-nav {
        margin-top: 0;
      }
      &.is-open {
        max-height: 1000px; /* 设定一个足够大的值，确保内容完全展开 */
      }
      .nav-item-content {
        padding-left: 27px;
      }
    }

    .nav-item-content {
      padding: 0 7px;
      text-align: left;
      display: flex;
      align-items: center;
      height: 36px;
      color: #828591;
      font-size: 14px;
      .circle-icon {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        margin-right: 6px;
        background: #ccc;
      }
      .icon-box {
        width: 20px;
        height: 20px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        // line-height: 20px;
        margin-right: 6px;
        .tri-icon {
          display: inline-block;
          width: 0;
          height: 0;
          border-left: 4px solid #bababa;
          position: relative;
          top: -3px;
          border-top: 3px solid transparent;
          border-bottom: 3px solid transparent;
          // position: relative;
          // top: -3px
        }
        .iconfont {
          display: inline-block;
          font-size: 16px;
          width: 16px;
          height: 16px;
          color: #a4a7b6;
        }
        &.is-parent-icon-box {
          // visibility: hidden;
          display: none;
        }
        &.is-child-icon-box {
          display: block;
        }
        &.is-leaf-icon-box {
          display: none;
        }
        .circle-icon {
          margin-right: 0;
        }
      }

      &.router-link-active {
        // background: #e6f2ff;
        color: #0057ff;
        border-radius: 6px;
        .circle-icon {
          background: #4494ff;
        }
        .icon-box {
          .iconfont {
            color: #0057ff;
          }
        }
      }
      &:hover {
        border-radius: 6px;
        background: #e5ecf3;
      }
      &.parent-menu-active {
        color: #1a1a1a;
        .tri-icon {
          &.is-active {
            // margin-top: 4px;
            display: inline-block;
            width: 0;
            height: 0;
            border-left: 4px solid #bababa;
            position: relative;
            top: -3px;
            border-top: 3px solid transparent;
            border-bottom: 3px solid transparent;
          }
        }
      }
    }
    &.leaf-nav-item {
      .nav-item-content {
        // padding: 0;
        // margin-top: 4px;
      }
      &.is-parent {
        .nav-item-content {
          &:hover {
            // background: transparent;
          }
          // justify-content: center;
        }
      }
    }
    &.is-desktop {
      border-bottom: 1px solid #eeeeee;
      margin-bottom: 8px;
      padding-bottom: 8px;
      .nav-item-content {
        padding: 0 6px;
      }
    }
    &.open {
      .nav-item-content {
        .icon-box {
          .tri-icon {
            margin-top: 4px;
            display: inline-block;
            width: 0;
            height: 0;
            border-top: 4px solid #bababa;
            border-left: 3px solid transparent;
            border-right: 3px solid transparent;
            position: relative;
            top: 0;
          }
        }
        // .circle-icon{
        //   background: #ccc;
        // }
        &.parent-menu-active {
          .icon-box {
            .tri-icon {
              border-top: 4px solid #bababa;
            }
          }
          .circle-icon {
            background: #4494ff;
          }
        }
      }
    }
    &.is-parent {
      // margin-bottom: 4px;
      &.is-desktop {
        margin-bottom: 8px;
      }
    }
  }
}

.arrow {
  float: right;
  transition: transform 0.1s;
}

.arrow.open {
  transform: rotate(180deg);
}

.sub-menu {
  // padding-left: 20px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease-out;
}

.slide-enter-active,
.slide-leave-active {
  max-height: 1000px;
  transition: all 0.1s ease;
}

.slide-enter,
.slide-leave-to {
  max-height: 0;
}
</style>
